export default __webpack_public_path__ + "static/PPObjectSans-Heavy-a7a775c5787037f5bafbb0d26774604c.ttf";